/* eslint-disable prettier/prettier */
import lazyWithRetry from "@shared/lazyWithRetry";

const portfolios = import("@pages/FundPortfolio/FundPortfolios");

const Home = lazyWithRetry(() => import("@pages/Home/Home"));
const MyInsurance = lazyWithRetry(() => import("@pages/myInsurance/List"));
const Fondtorg = lazyWithRetry(() => import("@pages/funds/List"));
const Support = lazyWithRetry(() => import("@pages/Support"));
const InsuranceDetails = lazyWithRetry(() =>
  import("@pages/myInsurance/Details")
);
const PortfolioDetails = lazyWithRetry(() =>
  import("@pages/myFundPortfolio/Details")
);
const FundDetails = lazyWithRetry(() =>
  import("@pages/myFundPortfolio/FundDetails")
);
const MyProfile = lazyWithRetry(() => import("@pages/MyProfile"));
const Login = lazyWithRetry(() => import("@pages/auth/Login"));
const FundPortfolios = lazyWithRetry(() => portfolios);
const NotificationList = lazyWithRetry(() =>
  import("@pages/notifications/List")
);
const Wizard = lazyWithRetry(() => import("@pages/wizards"));
const PendingOrders = lazyWithRetry(() =>
  import("@pages/wizards/PendingOrdersError")
);
const CreateAccount = lazyWithRetry(() => import("@pages/Home/CreateAccount"));
const IncorrectAccount = lazyWithRetry(() =>
  import("@pages/wizards/IncorrectAccount")
);
const ErrorPage = lazyWithRetry(() => import("@pages/Error"));
const LogoutPage = lazyWithRetry(() => import("@pages/auth/Logout"));
const MaintenancePage = lazyWithRetry(() => import("@pages/MaintenancePage"));

import {
  SVLANG,
  ROUTES,
  NOTIFICATION,
  MY_INSURANCE,
  FUND,
  FUND_PORTFOLIO,
} from "@utils/constant";

export const RoutesList = [
  {
    url: ROUTES.HOME.URL,
    title: SVLANG.home,
    component: [Home],
    showSidemenu: ROUTES.HOME.showSidemenu,
  },
  {
    url: ROUTES.LANDING_PAGE.URL,
    title: SVLANG.login,
    component: [Login],
  },
  {
    url: ROUTES.NOTIFICATIONS.URL,
    title: NOTIFICATION,
    component: [NotificationList],
    showSidemenu: ROUTES.NOTIFICATIONS.showSidemenu,
  },
  {
    url: ROUTES.MY_INSURANCE.URL,
    title: MY_INSURANCE,
    component: [MyInsurance],
    showSidemenu: ROUTES.MY_INSURANCE.showSidemenu,
  },
  {
    url: ROUTES.FONDTORG.URL,
    title: FUND,
    component: [Fondtorg],
    showSidemenu: ROUTES.FONDTORG.showSidemenu,
  },
  {
    url: ROUTES.SUPPORT.URL,
    title: SVLANG.support,
    component: [Support],
    showSidemenu: ROUTES.SUPPORT.showSidemenu,
  },
  {
    url: ROUTES.MY_INSURANCE_DETAILS.URL,
    title: SVLANG.my_insurance,
    component: [InsuranceDetails],
    showSidemenu: ROUTES.MY_INSURANCE_DETAILS.showSidemenu,
  },
  {
    url: ROUTES.MY_FUND_PORTFOLIO_DETAILS.URL,
    title: FUND_PORTFOLIO,
    component: [PortfolioDetails],
    showSidemenu: ROUTES.MY_FUND_PORTFOLIO_DETAILS.showSidemenu,
  },
  {
    url: ROUTES.FUND_DETAILS.URL,
    title: SVLANG.title_my_funds,
    component: [FundDetails],
    showSidemenu: ROUTES.FUND_DETAILS.showSidemenu,
  },
  {
    url: ROUTES.WIZARD_FUND_PORTFOLIO_DETAILS.URL,
    title: SVLANG.FUND_PORTFOLIO,
    component: [PortfolioDetails],
    isWizard: ROUTES.WIZARD_FUND_PORTFOLIO_DETAILS.isWizard,
  },
  {
    url: ROUTES.WIZARD_FUND_DETAILS.URL,
    title: SVLANG.title_my_funds,
    component: [FundDetails],
    isWizard: ROUTES.WIZARD_FUND_DETAILS.isWizard,
  },
  {
    url: ROUTES.MY_PROFILE.URL,
    title: SVLANG.my_details,
    component: [MyProfile],
    showSidemenu: ROUTES.MY_PROFILE.showSidemenu,
  },
  {
    url: ROUTES.LOGIN.URL,
    title: SVLANG.login,
    component: [Login],
  },
  {
    url: ROUTES.WIZARD_START.URL,
    title: SVLANG.insurance,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_START.isWizard,
  },
  {
    url: ROUTES.WIZARD_ACCEPT_TERMS.URL,
    title: SVLANG.insurance,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_ACCEPT_TERMS.isWizard,
  },
  {
    url: ROUTES.WIZARD_DISTRIBUTION.URL,
    title: SVLANG.title_change_funds_distribution,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_DISTRIBUTION.isWizard,
  },
  {
    url: ROUTES.WIZARD_PREVIEW.URL,
    title: SVLANG.title_change_funds_distribution,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_PREVIEW.isWizard,
  },
  {
    url: ROUTES.WIZARD_SUCCESS.URL,
    title: SVLANG.text_clear,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_SUCCESS.isWizard,
  },
  {
    url: ROUTES.WIZARD_MANAGEMENT.URL,
    title: SVLANG.title_change_funds_distribution,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_MANAGEMENT.isWizard,
  },
  {
    url: ROUTES.WIZARD_FUNDS.URL,
    title: SVLANG.fondtorg,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_FUNDS.isWizard,
  },
  {
    url: ROUTES.WIZARD_CHANGE_FUND_PORTFOLIO.URL,
    title: SVLANG.title_change_fund_portfolio_distribution,
    component: [Wizard],
    isWizard: ROUTES.WIZARD_CHANGE_FUND_PORTFOLIO.isWizard,
  },
  {
    url: ROUTES.FUND_PORTFOLIOS.URL,
    title: SVLANG.fund_portfolios,
    component: [FundPortfolios],
    showSidemenu: ROUTES.FUND_PORTFOLIOS.showSidemenu,
  },
  {
    url: ROUTES.PENDING_ORDERS.URL,
    title: SVLANG.text_pending_orders,
    component: [PendingOrders],
  },
  {
    url: ROUTES.CREATE_ACCOUNT.URL,
    title: SVLANG.text_pending_orders,
    component: [CreateAccount],
  },
  {
    url: ROUTES.INCORRECT_ACCOUNT.URL,
    title: SVLANG.text_pending_orders,
    component: [IncorrectAccount],
  },
  {
    url: ROUTES.PUBLIC_MY_FUND_PORTFOLIO_DETAILS.URL,
    title: FUND_PORTFOLIO,
    component: [PortfolioDetails],
  },
  {
    url: ROUTES.PUBLIC_FUND_PORTFOLIOS.URL,
    title: SVLANG.fund_portfolios,
    component: [FundPortfolios],
  },
  {
    url: ROUTES.ERROR_PAGE.URL,
    title: SVLANG.error,
    component: [ErrorPage],
  },
  {
    url: ROUTES.LOGOUT_PAGE.URL,
    title: SVLANG.logout_success,
    component: [LogoutPage],
  },
  {
    url: ROUTES.MAINTENANCE_PAGE.URL,
    title: SVLANG.error,
    component: [MaintenancePage],
  },
];

export default RoutesList;
